import { useEffect, useState } from "react";
import { Button } from "../ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "../ui/dialog";
import { Label } from "../ui/label";
import { Textarea } from "../ui/textarea";

export function VariationReasonDialog({
  open,
  onCancel,
  onConfirm,
}: {
  open: boolean;
  onCancel: () => void;
  onConfirm: (reason: string) => void;
}) {
  const [reason, setReason] = useState("");
  const trimmed = reason.trim();

  useEffect(() => {
    if (open) setReason("");
  }, [open]);

  return (
    <Dialog open={open} onOpenChange={(next) => !next && onCancel()}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>Why are you creating this variation?</DialogTitle>
          <DialogDescription>
            Record the intended outcome so this version remains understandable when you review it later.
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-2">
          <Label htmlFor="variation-reason">Reason for the change</Label>
          <Textarea
            id="variation-reason"
            autoFocus
            rows={4}
            placeholder="For example: Tighten the midpoint pacing while preserving the reveal."
            value={reason}
            onChange={(event) => setReason(event.target.value)}
          />
          <p className="text-xs leading-relaxed text-muted-foreground">
            This reason will appear with the variation’s instructions, model, and status.
          </p>
        </div>
        <DialogFooter>
          <Button type="button" variant="outline" onClick={onCancel}>
            Cancel
          </Button>
          <Button
            type="button"
            disabled={trimmed.length < 3}
            onClick={() => {
              if (trimmed.length < 3) return;
              onConfirm(trimmed);
            }}
          >
            Generate variation
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
